module.exports = __webpack_public_path__ + "img/milestone__1963.ae6b55ba.jpg";